import { IconProps } from '../../types/IconProps';

export const Clear = ({ variant, className }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    className={`${className || ''}`}>
    <path
      fill={variant === 'light' ? '#fff' : '#0B223E'}
      d='m15.621 9.364-2.534 2.531 2.534 2.532a.77.77 0 1 1-1.088 1.088L12 12.982l-2.533 2.533a.77.77 0 0 1-1.088-1.088l2.534-2.532-2.534-2.531a.77.77 0 1 1 1.088-1.088L12 10.808l2.533-2.532a.77.77 0 0 1 1.088 1.088ZM22 11.895c0 7.694-8.333 12.503-15 8.656C.333 16.704.333 7.087 7 3.24a10.004 10.004 0 0 1 5-1.34c5.52.006 9.994 4.478 10 9.995Zm-1.538 0c0-6.51-7.052-10.579-12.693-7.324-5.64 3.255-5.64 11.393 0 14.648A8.467 8.467 0 0 0 12 20.352c4.671-.005 8.456-3.788 8.462-8.457Z'
    />
  </svg>
);
